import React, { Component } from 'react';
import { connect } from "react-redux";
import 'react-quill/dist/quill.snow.css';
import moment from 'moment';
import ReactModal from 'react-modal';
import ConversationExpand from './ConversationExpand';
import { getConversationData } from '../../../actions/complaintsDataAction';

const customStyles = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    "overflow-y": "scroll"
  },
  content: {
    inset: '0 0 auto',
    marginRight: '0',
    transform: 'translate(0)',
    background: '#1a1a1a',
    padding: '2rem',
    border: 'none',
    width: '100%',
    position: 'absolute',
    "overflow-y": 'scroll',
    height: '100%'
  },
};

class Conversations extends Component {
  constructor() {
    super();
    this.state = {
      showExpandedConversation: false,
      pageno: 1,
      conversationLIST: [],
      isLoading: false
    };
    this.showConversation = this.showConversation.bind(this);
    this.expandFunction = this.expandFunction.bind(this);
    this.getConversationComplaits = this.getConversationComplaits.bind(this);
  }

  componentDidMount() {
    this.getConversationComplaits();
    var myDiv = document.getElementById("conversation_head");
    // myDiv.scrollTop = myDiv.scrollHeight - myDiv.clientHeight;
  }


  getConversationComplaits = async () => {
    this.setState({ isLoading: true });
    let response = await this.props.getConversationData(this.props.complaintsDetail.id, this.state.pageno);
    this.setState({ conversationLIST: response, isLoading: false });
  };

  showConversation() {
    this.setState({ showExpandedConversation: true });
  }

  expandFunction = async (val) => {
    this.setState({ showExpandedConversation: val });
    if (!val) {
      let response = await this.props.getConversationData(this.props.complaintsDetail.id, 1);
      this.setState({ conversationLIST: response });
    }
  };

  loadMore = async () => {
    let response = await this.props.getConversationData(this.props.complaintsDetail.id, this.state.pageno + 1);
    this.setState({ conversationLIST: [...this.state.conversationLIST, ...response] });
  };

  render() {
    let userRoleId = localStorage.getItem('userRoleId');
    return (
      <div>
        {!this.state.isLoading ?
          <div>
            {userRoleId !== '4' &&
              <div className="expand_wrapper" onClick={this.showConversation}>
                <i className="fa fa-expand" aria-hidden="true"></i>
              </div>
            }
            <div className="head conversation_head" id="conversation_head">

              {
                this.state.conversationLIST.map((b, index) => (
                  <div key={b.id} style={{ width: "100%", float: "left" }}>
                    {!b.user &&
                      <div>
                        {b.from_email != null
                          ?

                          <div id="coversation_body" className={b.from_email !== "NOISE <help@nexxbase.com>" && 'incoming'} >

                            <div>
                              {b.from_email !== "NOISE <help@nexxbase.com>" &&
                                <h3>Customer Reply</h3>
                              }
                              <p>{b.body_text}</p>
                              <p id="created_at">{moment(b.created_at, ["MMMM DD, YYYY || HH.mm"]).format('MMMM DD, YYYY || hh:mm A')}</p>
                            </div>

                          </div>
                          :
                          <div id="coversation_body" className={b.to_emails === '' && "yellowBG"} >

                            <div>

                              <p>{b.body_text}</p>
                              <p id="created_at">{moment(b.created_at, ["MMMM DD, YYYY || HH.mm"]).format('MMMM DD, YYYY || hh:mm A')}</p>
                            </div>

                          </div>
                        }
                      </div>}


                  </div>
                ))
              }
              {this.props.conversationpage.next_page == true &&
                <div className="expand_wrapper" onClick={this.loadMore}>
                  <button className='loadMoreBUtton'>Load more..</button>
                </div>}
            </div>
          </div> :
          <div>
            <i id="loadingText">Please wait ....</i>
          </div>}


        <ReactModal
          isOpen={this.state.showExpandedConversation}
          contentLabel="Minimal Modal Example"
          style={customStyles}
          ariaHideApp={false}
          id="conversationExpand"
        >
          <ConversationExpand complaintId={this.props.complaintsDetail.id} showExpandedConversation={this.expandFunction} conversationData={this.state.conversationLIST} pageno={this.state.pageno} />
        </ReactModal>

      </div>
    );
  }
}


const mapStateToProps = state => ({
  conversationpage: state.complaints.conversationpage,
  complaintsDetail: state.complaints.complaintsDetail,
  conversationDetails: state.complaints.conversationDetails,
});

export default connect(mapStateToProps, { getConversationData })(Conversations);